// If all else fails, suppress errors in production to prevent leaking uncaught exception errors.
export const suppressListPromiseError = (): Promise<never[]> =>
  Promise.resolve([]);

// If all else fails, suppress errors in production to prevent leaking uncaught exception errors.
export const suppressObjectPromiseError = (): Promise<null> =>
  Promise.resolve(null);
